<app-fbdms-header *ngIf="showFbdmsHeader"></app-fbdms-header>
<header class="navbar navbar-expand-lg bd-navbar shadow-sm text-bg-light" [ngClass]="{'fixed-top':!showFbdmsHeader}">
  <nav class="container-fluid bd-gutter flex-wrap flex-lg-nowrap" aria-label="Main navigation">
    <!-- BRANDING BEGINS -->
    <div class="logo">
      <img src="{{logo}}" alt="Logo" class="img-fluid logo-img" aria-label="Brand Logo">
    </div>
    <!-- BRANDING ENDS -->
  </nav>
</header>